"use client"

import type { BarracksSoldier } from "@/types/barracks.types"
import { getFootmanConfig } from "@/data/barracks-config"

// Spritesheet constants
const SOLDIER_SPRITESHEET = "/images/towers/barracks/portraits/soldiers.png"
const SPRITE_SIZE = 64 // Each portrait is 64x64 pixels

interface SoldierPortraitSectionProps {
  soldier: BarracksSoldier
  barracksTowerLevel: number
  onDeselectSoldier?: () => void
  scale: number
}

export const SoldierPortraitSection = ({
  barracksTowerLevel,
  onDeselectSoldier,
  scale,
}: SoldierPortraitSectionProps) => {
  const effectiveScale = scale > 0 ? scale : 1
  const width = 84 * effectiveScale
  const height = 84 * effectiveScale
  const left = 19 * effectiveScale
  const top = 26 * effectiveScale

  // Get soldier config for the name (using barracks level, not soldier's current level)
  const soldierConfig = getFootmanConfig(barracksTowerLevel)

  // Calculate sprite position in the spritesheet (levels 1-7, left to right)
  // Use barracks tower level for portrait (shows what soldier will become on respawn)
  const spriteIndex = barracksTowerLevel - 1 // 0-indexed
  const spriteOffsetX = spriteIndex * SPRITE_SIZE

  return (
    <div
      id="soldier-portrait-section"
      className="absolute"
      style={{
        left,
        top,
        width,
        height,
      }}
    >
      <button
        id="soldier-portrait-button"
        onClick={onDeselectSoldier}
        className="w-full h-full relative overflow-hidden transition-all hover:brightness-110 border-2 border-amber-600"
        title="Click to deselect soldier"
      >
        {/* Soldier portrait from spritesheet */}
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundImage: `url(${SOLDIER_SPRITESHEET})`,
            backgroundPosition: `-${spriteOffsetX * (width / SPRITE_SIZE)}px 0`,
            backgroundSize: `${7 * width}px ${height}px`,
            imageRendering: "pixelated",
          }}
          aria-label={`${soldierConfig.name} portrait`}
        />

        {/* Selection indicator */}
        <div className="absolute inset-0 border-2 border-amber-400 animate-pulse pointer-events-none" />
      </button>
    </div>
  )
}
